const AnimatedLogo = ({ size = "default" }) => {
  const sizeClasses = {
    small: "h-14",
    default: "h-20 md:h-24",
    large: "h-24 md:h-32 lg:h-36",
  };

  return (
    <div data-testid="animated-logo" className="inline-block">
      <img
        src="https://customer-assets.emergentagent.com/job_orange-glaze/artifacts/uwv1ms6g_cglancey%20double%20glazing.png"
        alt="C. Glancey Glazing | Windows & Doors"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default AnimatedLogo;
